// extracted by mini-css-extract-plugin
export default {"container":"CardTable_container__-JopH","card":"CardTable_card__Ela8F"};